/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomerCreditsBaseDataFragment = {
  readonly __typename?: 'Customer';
  readonly id: string;
  readonly availableCredit: number;
  readonly useCredit: boolean;
};

export type CustomerCreditsDataFragment = {
  readonly __typename?: 'Credit';
  readonly id: string;
  readonly title: string;
  readonly remainingAmount: number;
  readonly expiresAt: string | null;
};

export type CustomerCreditsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CustomerCreditsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly availableCredit: number;
    readonly useCredit: boolean;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly createdAt: string;
      readonly id: string;
      readonly title: string;
      readonly remainingAmount: number;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export type CustomerCreditsWithNewFieldsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CustomerCreditsWithNewFieldsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly availableCredit: number;
    readonly useCredit: boolean;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly storefrontEligibilityTitle: string;
      readonly creditType: Types.CreditType;
      readonly id: string;
      readonly title: string;
      readonly remainingAmount: number;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export const customerCreditsQueryMock: ExecutionResult<CustomerCreditsQuery> = {
  data: {
    currentCustomer: {
      id: 'e509e6ea-9fee-442a-9962-587ce7190430',
      availableCredit: 4,
      useCredit: true,
      credits: [
        {
          id: '7a7163ba-7eda-496e-8a18-5e3da00a9a47',
          title: 'Hello World',
          remainingAmount: -35.53,
          expiresAt: 'Hello World',
          createdAt: 'Hello World',
        },
        {
          id: '34319d08-060b-459a-a250-f9c4016b1bd6',
          title: 'Hello World',
          remainingAmount: -57.58,
          expiresAt: 'Hello World',
          createdAt: 'Hello World',
        },
        {
          id: '4cb273b7-f9f1-48d0-b0f1-b1f2c49f5fd7',
          title: 'Hello World',
          remainingAmount: 15.65,
          expiresAt: 'Hello World',
          createdAt: 'Hello World',
        },
      ],
    },
  },
};

export const customerCreditsWithNewFieldsQueryMock: ExecutionResult<CustomerCreditsWithNewFieldsQuery> =
  {
    data: {
      currentCustomer: {
        id: '94ccdcab-38b7-4485-afbe-88532ede7a1d',
        availableCredit: 35,
        useCredit: true,
        credits: [
          {
            id: '33e0e095-a7b4-48f0-bb56-0d0180d39ca0',
            title: 'Hello World',
            remainingAmount: 61.42,
            expiresAt: 'Hello World',
            storefrontEligibilityTitle: 'Hello World',
            creditType: 'ALL_NATIVE_STOREFRONTS',
          },
          {
            id: '0520a352-a4a6-4541-b5bc-5d089f52e921',
            title: 'Hello World',
            remainingAmount: 70.34,
            expiresAt: 'Hello World',
            storefrontEligibilityTitle: 'Hello World',
            creditType: 'ALL_NATIVE_STOREFRONTS',
          },
        ],
      },
    },
  };
export const CustomerCreditsBaseDataFragmentDoc = gql`
  fragment customerCreditsBaseData on Customer {
    id
    availableCredit
    useCredit
  }
`;
export const CustomerCreditsDataFragmentDoc = gql`
  fragment customerCreditsData on Credit {
    id
    title
    remainingAmount
    expiresAt
  }
`;
export const CustomerCreditsDocument = gql`
  query CustomerCredits {
    currentCustomer {
      ...customerCreditsBaseData
      credits {
        ...customerCreditsData
        createdAt
      }
    }
  }
  ${CustomerCreditsBaseDataFragmentDoc}
  ${CustomerCreditsDataFragmentDoc}
`;

export function useCustomerCreditsQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerCreditsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerCreditsQuery, CustomerCreditsQueryVariables>({
    query: CustomerCreditsDocument,
    ...options,
  });
}
export const CustomerCreditsWithNewFieldsDocument = gql`
  query CustomerCreditsWithNewFields {
    currentCustomer {
      ...customerCreditsBaseData
      credits {
        ...customerCreditsData
        storefrontEligibilityTitle
        creditType
      }
    }
  }
  ${CustomerCreditsBaseDataFragmentDoc}
  ${CustomerCreditsDataFragmentDoc}
`;

export function useCustomerCreditsWithNewFieldsQuery(
  options?: Omit<
    Urql.UseQueryArgs<CustomerCreditsWithNewFieldsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    CustomerCreditsWithNewFieldsQuery,
    CustomerCreditsWithNewFieldsQueryVariables
  >({ query: CustomerCreditsWithNewFieldsDocument, ...options });
}
